import { useState, useEffect } from 'react';
import { CreditCard, Trash2, Star, Loader2, Lock } from 'lucide-react';
import { subscriptionApi } from '../lib/api';
import { toast } from 'sonner';

const CardWallet = () => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadCards();
  }, []);

  const loadCards = async () => {
    try {
      const response = await subscriptionApi.getSavedCards();
      setCards(response.data || []);
    } catch (error) {
      console.error('Error loading cards:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteCard = async (cardId) => {
    if (!confirm('¿Estás seguro de eliminar esta tarjeta?')) return;
    
    try {
      await subscriptionApi.deleteCard(cardId);
      toast.success('Tarjeta eliminada');
      loadCards();
    } catch (error) {
      toast.error('Error al eliminar la tarjeta');
    }
  };

  const handleSetPrimary = async (cardId) => {
    try {
      await subscriptionApi.setPrimaryCard(cardId);
      toast.success('Tarjeta principal actualizada');
      loadCards();
    } catch (error) {
      toast.error('Error al actualizar');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center p-8">
        <Loader2 className="animate-spin text-[#D4AF37]" size={24} />
      </div>
    );
  }

  return (
    <div className="space-y-4" data-testid="card-wallet">
      {/* Cards List */}
      {cards.length > 0 ? (
        <div className="space-y-3">
          {cards.map((card) => (
            <div
              key={card.id}
              className="p-4 bg-[#18181B] border border-[#27272A] rounded-lg flex items-center justify-between"
              data-testid={`wallet-card-${card.id}`}
            >
              <div className="flex items-center gap-4">
                <div className={`p-3 rounded-lg ${card.is_primary ? 'bg-[#D4AF37]' : 'bg-[#27272A]'}`}>
                  <CreditCard size={24} className={card.is_primary ? 'text-black' : 'text-[#71717A]'} />
                </div>
                <div>
                  <div className="flex items-center gap-2">
                    <span className="text-white font-medium">
                      {card.card_brand} •••• {card.last_four}
                    </span>
                    {card.is_primary && (
                      <span className="text-xs bg-[#D4AF37]/20 text-[#D4AF37] px-2 py-0.5 rounded">
                        Principal
                      </span>
                    )}
                  </div>
                  <div className="text-sm text-[#71717A]">
                    {card.cardholder_name} • Vence {card.expiry_month}/{card.expiry_year}
                  </div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                {!card.is_primary && (
                  <button
                    onClick={() => handleSetPrimary(card.id)}
                    className="p-2 text-[#71717A] hover:text-[#D4AF37] transition-colors"
                    title="Hacer principal"
                  >
                    <Star size={18} />
                  </button>
                )}
                <button
                  onClick={() => handleDeleteCard(card.id)}
                  className="p-2 text-[#71717A] hover:text-red-500 transition-colors"
                  title="Eliminar"
                >
                  <Trash2 size={18} />
                </button>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 border border-dashed border-[#27272A] rounded-lg">
          <CreditCard size={32} className="mx-auto mb-2 text-[#27272A]" />
          <p className="text-[#71717A]">No tienes tarjetas guardadas</p>
          <p className="text-xs text-[#52525B] mt-2">
            Tus tarjetas se guardarán automáticamente al suscribirte
          </p>
        </div>
      )}
    </div>
  );
};

export default CardWallet;
